/**
 * Represents the type of a message.
 */
export const enum MessageType {
    Error = 0,
    Warning = 1,
}
